<template>
  <main-layout>
    <template #header>
      <main-header :title="'매출 확인' | translate" />
    </template>
      <template #feature>
          <div>
              <search-bar
                  v-model="selectOptions.searchKeyword"
                  :placeholder="'검색어' | translate"
                  style="width: 250px;"
              />
          </div>
      </template>
      <template #toolbar>
          <search-group-sales style="margin-bottom: 10px;" :select-options.sync="selectOptions" />
      </template>
    <template #body>
        <no-library-bagic-table
                          :table-body-data="ascendingSalesMonthTableData"
                          :disable-button="disableButton"
                          :is-page-sales="!salesListClickAutoSettingData"
                          @page-number-plus="pageNumberPlus"
                          @sort-option-change="sortOptionChange"
        />
      <div v-show="isLoading" class="loading_wrap">
        <div class="loading" />
        <div class="loading" />
        <div class="loading" />
      </div>
    </template>
</main-layout>
</template>

<script>
/**
 * 매출을 확인할 수 있는 컴포넌트입니다.
 *  1. 메뉴에서 매출을 클릭했을때
 *  2. 배치에서 매출 확인 버튼을 클릭했을때
 */
import MainLayout from "@/components/common/layout/MainLayout";
import SearchBar from "@/components/input/SearchBar";
import MainHeader from "@/components/common/layout/MainHeader";
import SearchGroupSales from "@/views/sales/SearchGroupSales";
import NoLibraryBagicTable from "@/views/sales/NoLibraryBagicTable";
import {PATH} from "@/constants";
import cloneDeep from "@/assets/plugins/mps-common/expansions/clone/cloneDeep";

export default {
  name: "SalesList",
  components: {
    MainLayout,
    MainHeader,
    SearchGroupSales,
    SearchBar,
    NoLibraryBagicTable
  },
  props :{
      /**
       * 배치에서 매출부분에 매출 확인 버튼 누르면
       * rentalcompanyId 가 props 로 전달되고 바로 목록을 보여주기 위함입니다.
       */
    salesListClickAutoSettingData:{
      type:Object
    }
  },
  data() {
    return{
      selectOptions : this.formatSelectOptions(), //모든 옵션 selectBox 에대한 데이터 입니다.
      isLoading:false,
      tableBodyData:[], //테이블에 뿌려줄 데이터입니다.
      pageNumber:1, //추가로드를 위한 데이터입니다.
        disableButton:false//추가로드버튼 클릭은 막기 위함입니다.
    }
  },
    computed: {
        /**
         * 매출월 기준으로 오름차순 정렬을 합니다.
         * sort자체가 원본배열을 건들이기 때문에 복사본을 만들어서 오름 차순하고
         * return하겠음 구현했습니다.
         * @returns {*[]}
         */
        ascendingSalesMonthTableData() {
            let ascendingTableData=[];
            cloneDeep(this.tableBodyData,ascendingTableData)
            ascendingTableData.sort((a,b)=>{
                return b.salesMonth-a.salesMonth
            })
            return ascendingTableData
        }
    },
  watch:{
    /**
     * 매출 부분에서 매출확인 버튼 클릭시 props로 넘어온 데이터에따라
     * 변화를 감지해서 selectOptions의 값을 바꿔줍니다.
     */
    salesListClickAutoSettingData :{
      deep:true,
      immediate:true,
      handler(newValue) {
        if(newValue) {
          this.selectOptions = {
            ...this.formatSelectOptions(),//모달 들어올때 데이터 초기화
            rentalcompanyId: newValue.rentalcompanyId,
            searchKeyword:newValue.companyName
          },
              this.tableBodyDataLoad('')
        }
      }
    },
    /**
     * select box 의 목록 중 하나를 선택시 selectOptions 부분이 바뀌고
     * 데이터를 요청합니다.
     */
    selectOptions:{
      deep:true,
      handler() {
        this.pageNumber =1; //옵션 선택할땐 페이지 1로 전부 초기화
        this.tableBodyDataLoad('')

      }
    },
    /**
     * 추가로드 버튼 을 클릭시 pageNumber가 변경되는데
     * 그 부분을 감지하여 데이터를 요청합니다.
     */
    pageNumber: {
      handler(newValue,oldValue){
        if(newValue<oldValue) return//pageNumber가 5인데 옵션을 선택시 중복 요청 방지
        this.tableBodyDataLoad('pageDataAdd')
      }
    }

  },
    created() {
      //회원관리에서 매출이동 버튼 클릭시 rentalcompanyId를 가지고 이동합니다.
      if(this.$route.query.rentalcompanyId) {
          this.selectOptions.rentalcompanyId= this.$route.query.rentalcompanyId
      }

    },
  methods : {
      /**
       * sorting 하는 함수입니다.
       *
       */
      sortOptionChange(e,selectOption,type) {
          this.tableBodyData.sort((a, b) => {
              let prev ,next ;
              if(type ==="number"){//숫자일때 비교
                  const numberA = Number(a[e])
                  const numberB = Number(b[e])
                  prev = numberA?numberA:0;
                  next = numberB?numberB:0;
              }else { //문자일때 비교
                  prev = a[e]?a[e].toUpperCase():'';
                  next = b[e]?b[e].toUpperCase():'';
              }
              if (prev < next) {//클때
                  return -1 * selectOption.sortOrder;
              }else if(prev > next) {//작을때
                  return 1 * selectOption.sortOrder;
              }else {//같을때
                  return 0;
              }
          });
      },
    /**
     * 데이터를 초기화 하는 로직입니다.
     * @returns {{salesTypeList: *[], endDate: undefined, cmsList: *[], billDayList: *[], pageSize: number, rentalcompanyId: undefined, serviceCdList: *[], paymentStatusList: *[], startDate: undefined}}
     */
    formatSelectOptions() {
      return {
        rentalcompanyId:undefined,
        serviceCdList:[],
        paymentStatusList:[],
        cmsList:[],
        salesTypeList:[],
        billDayList:[],
        deleteYn: null,
        startDate:undefined,
        endDate:undefined,
        pageSize:15,
      }
    },
      /**
       * 추가로드 버튼 클릭시 pageNumber 데이터를 1씩 증가합니다.
       */
      pageNumberPlus(){
        this.pageNumber++
      },
      /**
       * 응답받은 데이터가 없거나 테이블 자체에 데이터가 없을때 추가로드 버튼을 비활성화 합니다.
       * @param reqData
       */
      disableAddLoadButton(reqData){
          this.disableButton=!!reqData && !!reqData.length
      },
    /**
     * @param name
     * @returns {Promise<void>}
     * selectOptions 데이터를 body에 담아 거래처 목록을 가져옵니다.
     * name은 pageNumber 변경시(추가로드 버튼 클릭시) 데이터 계속 저장 or 데이터 초기화
     * 부분을 선택합니다.
     * 응답 데이터가 스네이크 형식으로 와서 카멜형식으로 바꿔줘야됩니다.
     */
    async tableBodyDataLoad(name) {
        this.isLoading=true;
       await this.$request(PATH.BILLING.LIST)
          .setObject({
            ...this.selectOptions, pageNumber: this.pageNumber
          }).catch((e)=>{
            this.isLoading =false;
            alert('조회실패')
          })
          .enqueue()
          .then(res => {
              this.disableAddLoadButton(res.data)
              this.tableBodyData = name ? //추가로드 클릭시 데이터 추가저장
                  [...this.tableBodyData,...res.data]
                  :[...res.data]
              this.isLoading = false;
          });
    }
  }


}
</script>

<style scoped>
/*search 부분이랑 select 부분 wrapper입니다*/
.loading_wrap {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  background: rgba(0,0,0,0.5);
}

.loading {
  width: 8px;
  height: 8px;
  background: #aaaaaa;
  border-radius: 50%;
  animation: loading-cricle 1.5s infinite ease-in-out;
  display: inline-block;
  margin-right: 8px;
}

.loading:nth-child(2) {
  animation-delay: .5s;
}

.loading:nth-child(3) {
  animation-delay: 1s;
}
@keyframes loading-cricle {
  0% {
    opacity: .4;
    transform: scale(1, 1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2, 1.2);
  }
  100% {
    opacity: .4;
    transform: scale(1, 1);
  }
}
/*Search Box 부분 font 랑 사이즈 조정 부분입니다*/
>>> .v-input__control .v-input__slot .v-text-field__slot input{
  font-size: 11px;
  padding: 0;
}

>>> .v-input__control .v-input__slot fieldset{
  height: 47px;
}
</style>